<template>
  <DropDownFilter
    :closeOnItemClick="true"
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    :storeModule="storeModule"
  />
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions } from 'vuex';
import CloudDirectoryFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/CloudDirectoryFilters';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';

const storeModule = StoreModuleMap[ItemTypeConsts.scimUserImport];

export default {
  name: 'ScimUsersImportSelectionDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data() {
    const dropDownMenuSections = [{
      menuLabel: 'Status:',
      menuItems: [
        {
          filter: CloudDirectoryFilters.isNew(true),
          label: 'New',
          action: () => {
            this.handleDropDownAction(CloudDirectoryFilters.isNew(true));
          },
        },
      ],
    }];
    return {
      dropDownMenuSections,
    };
  },

  methods: {
    ...mapActions(storeModule, [
      'setFilter',
      'fetchCollection',
    ]),
  },
};
</script>
